<template>
  <div>
    <!-- 搜索区域：标题搜索 + 查询/重置 + 新增 -->
    <div class="searchArea">
      <a-input v-model:value="searchName" placeholder="请输入标题" style="width: 260px; margin-right: 10px;" allowClear
        @pressEnter="fetchData" />

      <a-button type="primary" shape="circle" @click="fetchData">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>

      <a-button type="primary" style="margin-left: 20px" @click="showAddModal">
        <template #icon>
          <PlusOutlined />
        </template>
        新增商品展示信息
      </a-button>
    </div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data" :loading="loading"
      :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id"
      :pagination="{ pageSize: 12 }">

      <template #name="{ record }">
        <span>{{ record.name || '' }}</span>
      </template>

      <template #content="{ record }">
        <span v-if="record.imageUuid" class="content-image">
          <a-image :src="imageUrl + record.imageUuid" :width="60" :height="60"
            :style="{ objectFit: 'cover', borderRadius: '4px' }" alt="展示图" />
        </span>
        <span v-else-if="record.description" class="content-text">{{ record.description }}</span>
        <span v-else>--</span>
      </template>

      <template #operation="{ record, index }">
        <div class="flex_sa">
          <a @click="moveRow(index, -1)" :class="{ 'is-disabled': index === 0 }" style="margin-right: 8px;">
            <ArrowUpOutlined />
          </a>
          <a @click="moveRow(index, 1)" :class="{ 'is-disabled': index === data.length - 1 }"
            style="margin-right: 8px;">
            <ArrowDownOutlined />
          </a>

          <a-tooltip title="编辑">
            <a @click="showEditModal(record)">
              <FormOutlined />
            </a>
          </a-tooltip>

          <a-popconfirm title="确定要删除此条记录吗？" @confirm="handleDelete(record)" ok-text="确认" cancel-text="取消">
            <a-tooltip title="删除" style="margin-left: 12px;">
              <a class="text_danger">
                <DeleteOutlined />
              </a>
            </a-tooltip>
          </a-popconfirm>
        </div>
      </template>
    </a-table>

    <ProductDisplayModal v-model:visible="addVisible" :record="{}" @ok="handleSuccess" />
    <ProductDisplayModal v-model:visible="editVisible" :record="selectedRecord" @ok="handleSuccess" />
  </div>
</template>
<script>
import { SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import {
  GetMallSettingCategoryProduct,
  GetMallSettingList,
  DeleteMallSetting,
  SaveMallSettingOrder,
} from "/src/api/shopping.js";
import ProductDisplayModal from "../../components/shopping/ProductDisplayModal.vue";

const CATEGORY_NAME = "商品展示信息";

export default {
  name: "商品展示信息",
  components: {
    SearchOutlined,
    FormOutlined,
    DeleteOutlined,
    PlusOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    ProductDisplayModal,
  },
  data() {
    return {
      searchName: undefined,
      data: [],
      loading: false,
      addVisible: false,
      editVisible: false,
      selectedRecord: {},
      imageUrl: '/api/file/img/', // 原图
      thumbnailUrl: '/api/file/img/thumbnail/', // 缩略图
    };
  },
  computed: {
    columns() {
      return [
        { title: '标题', dataIndex: 'name', key: 'name', width: '25%', slots: { customRender: 'name' } },
        { title: '内容', key: 'content', width: '40%', slots: { customRender: 'content' } },
        { title: '顺序', dataIndex: 'orderIndex', key: 'orderIndex', width: '10%' },
        { title: '操作', key: 'operation', width: '25%', slots: { customRender: 'operation' } },
      ];
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 列表查询：无关键字用 category/product 全量展示；有关键字用 mall/setting/list 按标题搜索
    async fetchData() {
      this.loading = true;
      const clubId = this.$store.state.club?.id;
      const params = { category: CATEGORY_NAME, clubId };
      try {
        const res = await GetMallSettingList({ ...params, excludeEmpty: true, includeProduct: true, name: this.searchName })
        if (res.errCode === 0) {
          // 前端手动添加序号
          this.data = (res.data || []).map((item, index) => ({
            ...item,
            orderIndex: index + 1,
          }));
        } else {
          message.error(res.errMsg || "查询失败");
        }
      } catch (error) {
        console.error("Search error:", error);
        message.error("请求异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    resetSearch() {
      this.searchName = undefined;
      this.fetchData();
    },

    showAddModal() {
      this.addVisible = true;
    },

    showEditModal(record) {
      this.selectedRecord = { ...record };
      this.editVisible = true;
    },

    handleSuccess() {
      this.fetchData();
    },

    // 上移/下移
    moveRow(index, direction) {
      const targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= this.data.length) {
        return;
      }
      const temp = this.data[index];
      this.data.splice(index, 1);
      this.data.splice(targetIndex, 0, temp);

      this.data.forEach((item, idx) => {
        item.orderIndex = idx + 1;
      });
      this.saveRowOrder();
    },

    // 保存新的行顺序到后端
    async saveRowOrder() {
      const idOrder = this.data.map(item => item.id).filter(id => id);
      if (idOrder.length === 0) {
        message.warning('没有可排序的数据ID');
        return;
      }
      try {
        const res = await SaveMallSettingOrder(idOrder);
        if (res.errCode !== 0) {
          message.error(res.errMsg || '保存排序失败');
          this.fetchData();
        }
      } catch (error) {
        console.error("SaveMallSettingOrder error:", error);
        message.error("请求异常，保存排序失败");
        this.fetchData();
      }
    },

    async handleDelete(record) {
      try {
        const res = await DeleteMallSetting({ id: record.id });
        if (res.errCode === 0) {
          message.success("删除成功");
          this.fetchData();
        } else {
          message.error(res.errMsg || "删除失败");
        }
      } catch (error) {
        console.error("Delete error:", error);
        message.error("请求异常，请稍后重试");
      }
    },
  },
};
</script>

<style scoped>
.searchArea {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.content-image {
  display: inline-block;
}

.content-text {
  white-space: pre-wrap;
  word-break: break-word;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.6;
}

.flex_sa {
  display: flex;
  align-items: center;
}

.flex_sa a {
  color: rgba(0, 0, 0, 0.88);
  transition: color 0.3s;
}

.flex_sa a.is-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
  pointer-events: none;
}

.flex_sa .text_danger {
  color: #ff4d4f;
}
</style>
